import { render, staticRenderFns } from "./SpecialOffers.vue?vue&type=template&id=259c17d0&scoped=true&"
import script from "./SpecialOffers.vue?vue&type=script&lang=js&"
export * from "./SpecialOffers.vue?vue&type=script&lang=js&"
import style1 from "./SpecialOffers.vue?vue&type=style&index=1&id=259c17d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259c17d0",
  null
  
)

export default component.exports